$(".accordion-controller").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("open");
    var content = $(this).next();
    var icon = $(this).find("i").last();
    icon.toggleClass("fa-angle-down");
    icon.toggleClass("fa-angle-up");
    content.slideToggle();
});